"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEvent = void 0;

var React = __importStar(require("react"));

var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var defaultTarget = utils_1.isBrowser ? window : null;

var isPrimitiveListener = function isPrimitiveListener(target) {
  return !!target.addEventListener;
};

var isCustomListener = function isCustomListener(target) {
  return !!target.on;
};

function useEvent(name, handler, target, options) {
  if (target === void 0) {
    target = defaultTarget;
  }

  React.useEffect(function () {
    if (utils_1.isBrowser && target !== null) {
      if (isPrimitiveListener(target)) {
        target.addEventListener(name, handler, options);
      } else if (isCustomListener(target)) {
        target.on(name, handler, options);
      }

      return function cleanup() {
        if (isPrimitiveListener(target)) {
          target.removeEventListener(name, handler, options);
        } else if (isCustomListener(target)) {
          target.off(name, handler, options);
        }
      };
    }
  }, [name, handler, target, JSON.stringify(options)]);
}

exports.useEvent = useEvent;